// 腾讯审核待人工处理与人工下架分开展示，未知状态不推断为举报下架。
export function isPostUnderReview(post = {}) {
  const state = Number(post.contentState)
  return state === 4 || (state === 2 && Number(post.tencentAuditType) === 1)
}

export function postStateText(post = {}) {
  if (isPostUnderReview(post)) return '复审中'
  const labels = { 0: '审核中', 1: '已通过', 2: '已下架', 3: '被举报下架' }
  if (post.contentState === null || post.contentState === undefined || post.contentState === '') return '审核中'
  return labels[Number(post.contentState)] || '状态未知'
}
